import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function Whitepapers() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Whitepapers</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            RegTech whitepapers
            <br />
            built for decision-makers
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Executive-grade deep dives on compliance engineering, evidence automation, privacy technology, and operational resilience.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
            <Link to="/contact#contact-form" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8] px-5 text-sm font-semibold text-white hover:opacity-95">
              Request a whitepaper pack →
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-2">
            {[ 
              {
                t: "DPDPA 2023: From legal text to operating controls",
                d: "Translate consent, DSAR, cross-border transfer, and breach obligations into measurable controls and evidence pipelines.",
                links: [
                  { label: "DPDPA framework", href: "/frameworks/india/dpdpa" },
                  { label: "Dashboards", href: "/dashboards" },
                ],
              },
              {
                t: "Evidence Automation: Designing audit-ready telemetry",
                d: "A practical blueprint for converting policies into machine-checkable evidence using SIEM/SOAR, IAM, DSPM, and GRC workflows.",
                links: [
                  { label: "Technology mapping", href: "/technology-mapping" },
                  { label: "Offerings", href: "/offerings" },
                ],
              },
              {
                t: "Operational Resilience: DORA meets Indian BFSI",
                d: "Harmonize incident reporting, testing (TLPT), and third-party oversight across DORA and RBI expectations.",
                links: [
                  { label: "DORA", href: "/frameworks/international/dora" },
                  { label: "RBI", href: "/frameworks/india/rbi" },
                ],
              },
              {
                t: "OT/ICS Security for critical infrastructure",
                d: "Purdue-model segmentation, OT visibility, and IT-OT SOC integration patterns for regulated environments.",
                links: [
                  { label: "OT security", href: "/ot-security" },
                  { label: "Contact", href: "/contact#contact-form" },
                ],
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm leading-relaxed text-text-secondary">{x.d}</div>
                <div className="mt-5 flex flex-wrap gap-3">
                  {x.links.map((l) => (
                    <Link key={l.href} to={l.href} className="focus-ring inline-flex h-10 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                      {l.label} →
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Request downloads</div>
            <div className="mt-3 text-sm text-text-secondary">Tell us your sector and frameworks. We will share the most relevant pack.</div>
            <div className="mt-6">
              <ContactForm title="Whitepaper request" subtitle="We can also tailor a workshop around any paper." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
